const contentData = [
  {
    title: "他のアイデンティティプロバイダーを設定する",
    link: "https://auth0.com/docs/connections",
    description:
      "Auth0は、Facebook、Twitter、Instagramなど100以上のソーシャルプロバイダーや、Microsoft Office 365、Google Apps、Azureなどのエンタープライズプロバイダーをサポートしています。また、任意のOAuth2認可サーバーを使用することもできます。"
  },
  {
    title: "多要素認証を有効にする",
    link: "https://auth0.com/docs/multifactor-authentication",
    description:
      "多要素認証を有効にして、ユーザーに複数の識別情報を提供させることで、セキュリティを強化します。プッシュ通知、認証アプリ、SMS、DUO Securityがサポートされています。"
  },
  {
    title: "異常検知",
    link: "https://auth0.com/docs/anomaly-detection",
    description:
      "Auth0は異常を検知し、アプリケーションへの悪意のあるアクセス試行を阻止できます。異常検知は、疑わしい活動についてあなたやユーザーに警告し、さらなるログイン試行をブロックすることができます。"
  },
  {
    title: "APIについて学ぶ",
    link: "https://auth0.com/docs/api/management/v2/introduction",
    description:
      "Auth0 Management API は、管理タスクをプログラムで実行するためのAPI"
  }
];

export default contentData;
